const navStructure = [
  {
    text: {
      en: 'The Kingston Difference',
      zh: '京斯敦與眾不同之處',
    },
    key: 'the-kingston-difference',
    items: [
      {
        text: {
          en: 'Head Principal Welcome',
          zh: '總校長歡迎辭',
        },
        key: 'head-principal-welcome',
      },
      {
        text: {
          en: 'Mission, Purpose, and the Kingston Difference',
          zh: '使命、理念及京斯敦與眾不同之處',
        },
        key: 'mission-purpose-and-the-kingston-difference',
      },
      {
        text: {
          en: 'Approaches to Learning',
          zh: '京斯敦教學方法',
        },
        key: 'approaches-to-learning',
      },
      {
        text: {
          en: 'Alumni Testimonials',
          zh: '校友分享',
        },
        key: 'alumni-testimonials',
      },
      {
        text: {
          en: 'Kowloon Tong Community',
          zh: '九龍塘社區',
        },
        key: 'kowloon-tong-community',
      },
      {
        text: {
          en: 'Outreach',
          zh: '京斯敦外展項目',
        },
        key: 'outreach',
      },
    ],
  },

  {
    text: {
      en: 'Learning at Kingston',
      zh: '在京斯敦學習',
    },
    key: 'learning-at-kingston',
    items: [
      {
        text: {
          en: 'Kingston Early Years',
          zh: '京斯敦幼兒教育',
        },
        key: 'early-years',
        uri: '/learning-at-kingston/early-years/kik-kcc-curriculum',
        items: [
          {
            text: {
              en: 'Leadership Team',
              zh: '領導層',
            },
            key: 'leadership-team',
          },
          {
            text: {
              en: 'KIK/KCC Playgroup Curriculum',
              zh: '京斯敦國際幼稚園／京斯敦幼兒園課程',
            },
            key: 'kik-kcc-curriculum',
          },
          {
            text: {
              en: 'Primary Years Programme (IBPYP) at KIK',
              zh: '從幼稚園開始推行小學課程項目(IBPYP)',
            },
            key: 'ibpyp-at-kik',
          },
          {
            text: {
              en: 'Staff at KIK/KCC',
              zh: '教師團隊介紹',
            },
            key: 'staff',
          },
        ],
      },
      {
        text: {
          en: 'Playgroup Calendar',
          zh: '親子班曆表',
        },
        key: 'playgroup-calendar',
        url: '/calendar-kik-2024-2025.pdf',
      },
      {
        text: {
          en: 'KIK/KCC School Calendar',
          zh: '幼稚園／幼兒園校曆表',
        },
        key: 'kik-calendar',
        url: '/calendar-kik-2024-2025.pdf',
      },
      {
        text: {
          en: 'Kingston Primary School',
          zh: '京斯敦小學',
        },
        key: 'primary-school',
        uri: '/learning-at-kingston/primary-school/kis-approach-to-a-transdisciplinary-programme-of-inquiry',
        items: [
          {
            text: {
              en: 'Leadership Team',
              zh: '領導層',
            },
            key: 'leadership-team',
          },
          {
            text: {
              en: 'Staff at KIS',
              zh: '教師團隊介紹',
            },
            key: 'staff',
          },
          {
            text: {
              en: 'KIS Approach to a Transdisciplinary Programme of Inquiry',
              zh: '京斯敦的超學科探究課程教學方針',
            },
            key: 'kis-approach-to-a-transdisciplinary-programme-of-inquiry',
          },
          {
            text: {
              en: 'Our Bilingual Approach',
              zh: '雙語教學方針',
            },
            key: 'our-bilingual-approach',
          },
          {
            text: {
              en: 'Arts',
              zh: '藝術',
            },
            key: 'arts',
          },
          {
            text: {
              en: 'Athletics',
              zh: '體育',
            },
            key: 'athletics',
          },
          {
            text: {
              en: 'ICT and Commitment to Innovation',
              zh: '資訊科技及承諾創新改革',
            },
            key: 'ict-and-commitment-to-innovation',
          },
          {
            text: {
              en: 'Library at the Heart of our Program',
              zh: '圖書館是課程的核心',
            },
            key: 'library-at-the-heart-of-our-program',
          },
          {
            text: {
              en: 'Experiential Education',
              zh: '體驗教育',
            },
            key: 'experiential-education',
          },
        ],
      },
      {
        text: {
          en: 'Primary School Calendar',
          zh: '京斯敦小學校曆表',
        },
        key: 'kis-calendar',
        url: '/calendar-kis-2024-2025.pdf',
      },
      {
        text: {
          en: 'Secondary School',
          zh: '中學',
        },
        key: 'secondary-school',
        uri: '/learning-at-kingston/secondary-school/through-train-to-ichk',
        items: [
          {
            text: {
              en: 'Through Train to ICHK',
              zh: '一條龍中學 ICHK',
            },
            key: 'through-train-to-ichk',
          },
          {
            text: {
              en: 'Secondary Choices of Past Graduates',
              zh: '舊畢業生的中學選擇',
            },
            key: 'secondary-choices-of-past-graduates',
          },
        ],
      },
    ],
  },

  {
    text: {
      en: 'Life at Kingston',
      zh: '京斯敦的校園生活',
    },
    key: 'life-at-kingston',
    uri: '/life-at-kingston/student-well-being',
    items: [
      {
        text: {
          en: 'Student Well-being',
          zh: '學生的身心健康',
        },
        key: 'student-well-being',
      },
      {
        text: {
          en: 'Kindergarten Learning Spaces',
          zh: '幼稚園學習環境',
        },
        key: 'learning-spaces-kik',
      },
      {
        text: {
          en: 'Primary School Learning Spaces',
          zh: '小學學習環境',
        },
        key: 'learning-spaces-kis',
      },
      {
        text: {
          en: 'Clubs and Teams',
          zh: '學會／小組',
        },
        key: 'clubs-and-teams',
      },
      {
        text: {
          en: 'Extra Curricular Activities',
          zh: '課外活動',
        },
        key: 'eca',
      },
      {
        text: {
          en: 'Weather Information',
          zh: '天氣資訊',
        },
        key: 'weather-information',
      },
      {
        text: {
          en: 'Working at Kingston',
          zh: '在京斯敦工作',
        },
        key: 'working-at-kingston',
        uri: '/working-at-kingston/why-kingston',
      },
    ],
  },

  {
    text: {
      en: 'Admissions',
      zh: '入學',
    },
    key: 'admissions',
    uri: '/admissions/admissions-enquiry',
    items: [
      {
        text: {
          en: 'Admissions Enquiry',
          zh: '入學諮詢',
        },
        key: 'admissions-enquiry',
      },
      {
        text: {
          en: 'How to Apply',
          zh: '如何申請',
        },
        key: 'how-to-apply',
      },
      {
        text: {
          en: 'Fees and Charges',
          zh: '學費及其他收費',
        },
        key: 'fees-and-charges',
      },
      {
        text: {
          en: 'Entry Requirements',
          zh: '入學資格',
        },
        key: 'entry-requirements',
      },
      {
        text: {
          en: 'School Tour',
          zh: '校園導賞團',
        },
        key: 'school-tour',
      },
      {
        text: {
          en: 'Apply Online',
          zh: '網上入學申請',
        },
        key: 'apply-online',
        url: process.env.ADMISSIONS_URL,
      },
    ],
  },

  {
    text: {
      en: 'Working at Kingston',
      zh: '在京斯敦工作',
    },
    key: 'working-at-kingston',
    uri: '/working-at-kingston/why-kingston',
    items: [
      {
        text: {
          en: 'Why Work at Kingston',
          zh: '為什麼選擇京斯敦？',
        },
        key: 'why-kingston',
      },
      {
        text: {
          en: 'Testimonials',
          zh: '推薦信',
        },
        key: 'testimonials',
      },
      {
        text: {
          en: 'Job Openings',
          zh: '職位空缺',
        },
        key: 'job-openings',
        url: process.env.JOB_OPENINGS_URL,
      },
    ],
  },

  {
    text: {
      en: 'Contact Us',
      zh: '聯繫我們',
    },
    key: 'contact-us',
  },

  {
    text: {
      en: 'Parent Portal',
      zh: '家長平台',
    },
    key: 'parent-portal',
    url: process.env.PARENT_PORTAL_URL,
  },
];
const generateUri = (items, prevUri = '/') =>
  items.map(item => {
    const newUri = `${prevUri}${item.key}/`;
    const uri = !item.uri ? newUri : item.uri;
    const newItem = {
      ...item,
      uri,
    };
    if (item.items) {
      newItem.items = generateUri(item.items, newUri);
    }
    return newItem;
  });

const nav = generateUri(navStructure);

export default nav;

export const getNavItem = (...keys) => {
  let item;
  keys.forEach(key => {
    item = (item ? item.items || [] : nav).find(navItem => navItem.key === key);
  });
  return item;
};
